/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Зверніться до своєї команди або адміністратора за підтримкою.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'Не вдалося завантажити результати за цим запитом'
};